<template>
  <div class="page-actions" role="group" :aria-label="ariaLabel">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PageActions',
  props: {
    ariaLabel: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.page-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: var(--sid-space-2);
  min-width: 0;
}

@media (max-width: 599px) {
  .page-actions {
    width: 100%;
    align-items: stretch;
    flex-direction: column;
  }

  .page-actions :deep(.q-btn) {
    width: 100%;
    min-height: var(--sid-touch-target);
  }
}
</style>
